// extracted by mini-css-extract-plugin
export default {"v-med":"(max-width: 768px)","brandsWrapper":"marketing__brandsWrapper__TkwZC","reach":"marketing__reach__oeOMb","imageHeader":"marketing__imageHeader__M8eQp"};